
import ScrollToTop from './ScrollToTop'
export default {
  components: {
    ScrollToTop
  }
}
